export default {
  nav: { home: "Home", treatments: "Behandlungen", about: "Über mich", studio: "Studio", contact: "Kontakt" },
  cta: {
    book: "Termin vereinbaren",
    discover: "Behandlungen entdecken",
    moreAbout: "Mehr über mich",
    allTreatments: "Alle Behandlungen",
    send: "Anfrage senden",
    sending: "Wird gesendet…",
    call: "Jetzt anrufen",
    whatsapp: "Per WhatsApp schreiben",
    backHome: "Zurück zur Startseite",
    discoverStudio: "Das Studio entdecken",
    request: "Termin anfragen",
    readMore: "Mehr erfahren",
  },
  header: { openMenu: "Menü öffnen", closeMenu: "Menü schliessen", languageLabel: "Sprache wählen" },
  home: {
    heroEyebrow: "Beauty & Wellness · Basel",
    heroLines: ["Schönheit.", "Entspannung.", "Wohlbefinden."],
    heroWelcomePre: "Willkommen bei",
    heroWelcomeBrand: "IMPERIUM.",
    heroSub: "Professionelle Kosmetik und wohltuende Massagen für mehr Ausstrahlung, Ruhe und Wohlbefinden.",
    heroQuote: "„Persönliche Betreuung, hochwertige Behandlungen und eine Atmosphäre, in der Sie ganz bei sich ankommen.“",
    trustNo: "01",
    trustEyebrow: "Vertrauen",
    trustTitle: "Schönheit beginnt mit Vertrauen.",
    trustText: "Ihre Haut, Ihr Körper und Ihr Wohlbefinden verdienen Aufmerksamkeit. Bei IMPERIUM verbinden sich professionelle Behandlung, persönliche Beratung und eine Atmosphäre, in der Sie sich vollkommen wohlfühlen dürfen.",
    trustPoints: ["Persönliche Betreuung", "Individuelle Behandlung", "Hochwertige Atmosphäre", "Professionelle Kosmetik", "Zeit für Ihre Bedürfnisse"],
    servicesNo: "02",
    servicesEyebrow: "Behandlungen",
    servicesTitle: "Was darf heute für Sie im Mittelpunkt stehen?",
    servicesIntro: "Massage, Kosmetik und Styling – jede Behandlung individuell auf Sie abgestimmt.",
    auszeitNo: "03",
    auszeitEyebrow: "Ihre Auszeit",
    auszeitTitle: "Ihre Auszeit beginnt in dem Moment, in dem Sie sich für sich selbst entscheiden.",
    auszeitText: "Lassen Sie den Alltag für einen Moment hinter sich. Spüren Sie Ruhe, Pflege und neue Energie – individuell auf Sie abgestimmt.",
    ablaufEyebrow: "Ablauf",
    ablaufTitle: "So einfach beginnt Ihr Imperium-Moment",
    steps: [
      { t: "Behandlung auswählen", d: "Sie entdecken, was Ihnen heute guttun darf." },
      { t: "Kontakt aufnehmen", d: "Ganz einfach per Formular, WhatsApp oder Anruf." },
      { t: "Persönlich beraten werden", d: "Wir stimmen alles auf Sie und Ihre Wünsche ab." },
      { t: "Entspannt ankommen", d: "Sie treten ein und der Alltag bleibt draussen." },
      { t: "Behandlung geniessen", d: "Ihr Imperium-Moment – ganz für Sie." },
    ],
    expertNo: "04",
    expertEyebrow: "Ihre Expertin",
    expertName: "Leidiane Alcântara",
    expertText: "Fachfrau für Ästhetik und Wohlbefinden – mit Hingabe, kontinuierlicher Weiterbildung und einem aufmerksamen Blick für die individuellen Bedürfnisse jeder Person.",
    studioNo: "05",
    studioEyebrow: "Das Studio",
    studioTitle: "Ein Raum, der mit Liebe zum Detail entsteht.",
    studioText: "In Basel entsteht das IMPERIUM Beauty & Wellness – ein modernes, elegantes und komfortables Studio, geschaffen für ein vollständiges Erlebnis aus Schönheit, Pflege und Wohlbefinden.",
    galleryEyebrow: "Galerie",
    galleryTitle: "Einblicke in die Welt von IMPERIUM",
    finalTitle: "Bereit für Ihre schönste Auszeit?",
    finalText: "Nehmen Sie sich Zeit für sich. Wir freuen uns darauf, Sie persönlich kennenzulernen.",
    marquee: ["Kosmetik", "Massage", "Lymphdrainage", "Gesichtspflege", "Make-up", "Wohlbefinden"],
  },
  treatmentsPage: {
    eyebrow: "Behandlungen",
    title: "Ihre Behandlungen im IMPERIUM",
    intro: "Massage, Kosmetik und Styling – entdecken Sie, was Ihnen heute guttun darf. Jede Behandlung wird individuell auf Sie abgestimmt.",
    massage: "Massage & Körper",
    beauty: "Kosmetik & Styling",
  },
  treatment: {
    back: "Alle Behandlungen",
    related: "Weitere Behandlungen",
    ctaTitle: "Diese Behandlung anfragen",
    ctaText: "Erzählen Sie mir von Ihren Wünschen – ich berate Sie persönlich und wir finden gemeinsam Ihren Imperium-Moment.",
  },
  about: {
    eyebrow: "Über mich",
    title: "Leidiane Alcântara",
    role: "Ästhetik & Wohlbefinden",
    bio: [
      "Ich bin Leidiane Alcântara, Fachfrau für Ästhetik und Wohlbefinden – mit Leidenschaft dafür, Menschen zu pflegen und das Schönste in jeder Person zum Strahlen zu bringen.",
      "Mit Hingabe, kontinuierlicher Weiterbildung und einem aufmerksamen Blick für individuelle Bedürfnisse habe ich meinen Weg mit viel Arbeit, Verantwortung und Liebe zu dem aufgebaut, was ich tue.",
      "Ich glaube, dass jeder Mensch einzigartig ist. Deshalb biete ich eine persönliche Betreuung mit modernen und sicheren Techniken – immer mit dem Fokus auf Pflege, Ästhetik und Wohlbefinden.",
    ],
    storyEyebrow: "Die Geschichte",
    storyTitle: "Der Traum von IMPERIUM",
    story: [
      "Jetzt erfülle ich mir einen grossen Traum: Ich eröffne IMPERIUM Beauty & Wellness – ein wunderschönes Studio, geschaffen für ein vollständiges Erlebnis aus Schönheit, Pflege und Wohlbefinden.",
      "Jedes Detail wird mit viel Liebe vorbereitet, damit sich jede Kundin und jeder Kunde willkommen und wertgeschätzt fühlt und einen einzigartigen Moment in einem modernen, eleganten und komfortablen Ambiente erlebt.",
      "Es wird ein Ort, an dem Ästhetik, Entspannung und Selbstwertgefühl zusammenkommen – denn für Sie da zu sein, ist meine grösste Mission.",
    ],
    quote: "„Für Sie da zu sein ist meine grösste Mission.“",
    philosophyEyebrow: "Philosophie",
    philosophyTitle: "Jeder Mensch ist einzigartig.",
    philosophyText: "Persönliche Betreuung, moderne und sichere Techniken – immer mit dem Fokus auf Pflege, Ästhetik und Wohlbefinden.",
    ctaTitle: "Lernen wir uns kennen.",
    ctaText: "Ich freue mich auf Ihre Nachricht – persönlich, unkompliziert und ohne Verpflichtung.",
  },
  studio: {
    eyebrow: "Studio",
    title: "IMPERIUM in Basel",
    intro: "Ein Studio, geschaffen für Schönheit, Pflege und Wohlbefinden – modern, elegant und komfortabel.",
    preparing: "Das Studio wird zurzeit mit viel Liebe zum Detail vorbereitet. Jeder Winkel entsteht mit dem Ziel, dass Sie sich vom ersten Moment an willkommen und wertgeschätzt fühlen.",
    locationLabel: "Standort",
    location: "Austrasse 31, 4051 Basel, Switzerland",
    ctaTitle: "Seien Sie von Anfang an dabei.",
    ctaText: "Schreiben Sie mir – ich freue mich, von Ihnen zu hören.",
  },
  contact: {
    eyebrow: "Kontakt",
    title: "Ihr Imperium-Moment beginnt hier.",
    intro: "Ob Frage, Wunsch oder Termin – schreiben Sie mir. Ich melde mich persönlich bei Ihnen.",
    locationLabel: "Standort",
    phoneLabel: "Telefon & WhatsApp",
    emailLabel: "E-Mail",
    instagramLabel: "Instagram",
    formTitle: "Anfrage senden",
  },
  form: {
    name: "Vorname & Nachname",
    email: "E-Mail",
    phone: "Telefon (optional)",
    treatment: "Behandlung",
    treatmentPlaceholder: "Behandlung auswählen",
    noPreference: "Noch unsicher / Beratung",
    message: "Nachricht",
    messagePlaceholder: "Womit darf ich Ihnen helfen?",
    privacy: "Ich habe die Datenschutzerklärung gelesen und bin mit der Verarbeitung meiner Angaben zur Beantwortung meiner Anfrage einverstanden.",
    submit: "Anfrage senden",
    sending: "Wird gesendet…",
    success: "Vielen Dank! Ihre Anfrage ist angekommen. Ich melde mich so bald wie möglich persönlich bei Ihnen.",
    error: "Leider ist ein Fehler aufgetreten. Bitte versuchen Sie es erneut oder schreiben Sie mir per WhatsApp.",
    required: "Bitte füllen Sie alle Pflichtfelder aus.",
    invalidEmail: "Bitte geben Sie eine gültige E-Mail-Adresse ein.",
    privacyRequired: "Bitte bestätigen Sie die Datenschutzerklärung.",
  },
  footer: {
    tagline: "Kosmetik · Massage · Wohlbefinden",
    navTitle: "Navigation",
    treatmentsTitle: "Behandlungen",
    contactTitle: "Kontakt",
    legalTitle: "Rechtliches",
    impressum: "Impressum",
    privacy: "Datenschutz",
    rights: "Alle Rechte vorbehalten.",
    location: "Austrasse 31, 4051 Basel, Switzerland",
  },
  impressum: {
    title: "Impressum",
    operatorLabel: "Betreiberin",
    operator: "IMPERIUM Beauty & Wellness — Leidiane Alcântara",
    contactLabel: "Kontakt",
    contentLabel: "Verantwortlich für den Inhalt",
    note: "Die weiteren rechtlichen Angaben werden derzeit vervollständigt und in Kürze ergänzt.",
  },
  privacyPage: {
    title: "Datenschutzerklärung",
    responsibleTitle: "Verantwortliche Stelle",
    responsibleText: "IMPERIUM Beauty & Wellness — Leidiane Alcântara, Austrasse 31, 4051 Basel, Switzerland.",
    dataTitle: "Daten über das Kontaktformular",
    dataText: "Wenn Sie mir über das Formular schreiben, werden Ihre Angaben (Name, E-Mail, Telefon, Nachricht) ausschliesslich zur Beantwortung Ihrer Anfrage verwendet und nicht an Dritte weitergegeben.",
    storageTitle: "Speicherung im Browser",
    storageText: "Diese Website speichert lediglich Ihre Sprachwahl und Ihre Cookie-Entscheidung lokal in Ihrem Browser. Es werden keine Tracking-Cookies gesetzt.",
    rightsTitle: "Ihre Rechte",
    rightsText: "Sie haben jederzeit das Recht auf Auskunft, Berichtigung oder Löschung Ihrer Daten. Schreiben Sie dazu einfach an kontakt@imperium-wellness.ch.",
  },
  google: { label: "IMPERIUM auf Google", rate: "Auf Google bewerten", reviews: "Bewertungen ansehen" },
  notfound: {
    title: "404",
    heading: "Diese Seite wurde nicht gefunden.",
    text: "Vielleicht finden Sie hier, was Sie suchen:",
  },
  cookie: {
    text: "Diese Website verwendet nur technisch notwendige Speicherung – etwa für Ihre Sprachwahl. Es werden keine Tracking-Cookies gesetzt.",
    accept: "Verstanden",
    more: "Datenschutz",
  },
  seo: {
    homeTitle: "IMPERIUM Beauty & Wellness | Kosmetik, Ästhetik & Massagen in Basel",
    homeDesc: "Professionelle Kosmetik und wohltuende Massagen für mehr Ausstrahlung, Ruhe und Wohlbefinden. Ihre Schönheit. Ihr Moment. Ihr Imperium.",
  },
};
